<template>
  <div name="hres3cu-popup-complaint" id="hres3cu-popup-complaint" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">{{ labels['HRES3CUC4']['10'] }}</h4>
        </div>
        <div class="modal-body detail detail-responsive">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['20'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="desc_codempid" name="desc_codempid">{{ indexSelected.codempid }} - {{ indexSelected.desc_codempid }}</div>
                  </div>
              </div>
            
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['30'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="numcom" name="numcom">{{ indexSelected.numcom }}</div>
                  </div>
              </div> 
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['40'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="dtecompl" name="dtecompl">{{ setDateOutput(indexSelected.dtecompl) }}</div>
                  </div>
              </div> 
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['50'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="desc_typcompl" name="desc_typcompl">{{ detail.typcompl }} - {{ detail.desc_typcompl }}</div>
                  </div>
              </div>
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['60'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="descompl" name="descompl">{{ detail.descompl }}</div>
                  </div>
              </div> 
             
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['70'] }}</div>
                  <div class="detail-right">
                      <input type="radio" name="rad_1" value="N" v-model="indexSelected.stacompl" disabled="disabled"> <span class="radio-text">{{ labels['HRES3CUC4']['80'] }}</span>
                      <input type="radio" name="rad_1" value="D" v-model="indexSelected.stacompl" disabled="disabled"> <span class="radio-text">{{ labels['HRES3CUC4']['90'] }}</span>
                  </div>              
              </div> 
              <div class="clearfix detail-row">
                  <div class="detail-left label-left"></div>
                  <div class="detail-right">
                      <input type="radio" name="rad_2" value="S" v-model="indexSelected.stacompl" disabled="disabled"> <span class="radio-text">{{ labels['HRES3CUC4']['100'] }}</span>
                      <input type="radio" name="rad_2" value="C" v-model="indexSelected.stacompl" disabled="disabled"> <span class="radio-text">{{ labels['HRES3CUC4']['110'] }}</span>
                  </div>              
              </div>   
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['120'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="desc_codappv" name="desc_codappv">{{ detail.codappv }} - {{ detail.desc_codappv }}</div>
                  </div>
              </div>
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['130'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="filenam1" name="filenam1"><a :href="detail.path_filenam1" target="_blank">{{ detail.filenam1 }}</a></div>
                  </div>
              </div>
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['140'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="filenam2" name="filenam2"><a :href="detail.path_filenam2" target="_blank">{{ detail.filenam2 }}</a></div>
                  </div>
              </div>
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['150'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="filenam3" name="filenam3"><a :href="detail.path_filenam3" target="_blank">{{ detail.filenam3 }}</a></div>
                  </div>
              </div>
              <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES3CUC4']['160'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ detail.desnote }}</div>
                  </div>
              </div>
            </div>
          </div>
          </div>

        </div>
      </div>
   </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres3cu-popup-complaint',
  props: [ 'labels', 'detail', 'toggle', 'nowLang', 'labelsButton', 'indexSelected' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>


// WEBPACK FOOTER //
// popupComplaint.vue?ab1fe81c